module.exports = __webpack_public_path__ + "media/images/responsive/articles/logo_an-70da8422e69d0facae33f802b5c60c4c.svg";